// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1M7ZV","content":"styles_content__3nSjK","selectAll":"styles_selectAll__1WoWe"};